import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

	// 🔥 根路径自动适配 BASE_URL（修复跳转丢失 /test/）
	{
		path: '/',
		redirect: () => {
			const token = localStorage.getItem('token')
			const userType = localStorage.getItem('userType')

			if (!token) return '/login'

			switch (userType) {
				case '1':
					return '/admin/dashboard'
				case '2':
					return '/teacher/dashboard'
				case '3':
					return '/student/home'
				default:
					return '/login'
			}
		}
	},
	{
		path: '/student-list',
		redirect: '/teacher/interactiveClassroom'
	},

	// 登录
	{
		path: '/login',
		component: () => import('@/views/Login.vue')
	},

	// 学生端
	{
		path: '/student/home',
		component: () => import('@/views/student/Home.vue')
	},
	{
		path: '/student/testindex',
		component: () => import('@/views/student/test 1/index.vue')
	},
	{
		path: '/student/class',
		component: () => import('@/views/student/Classroom.vue')
	},
	{
		path: '/student/historyClassroom',
		component: () => import('@/views/student/historyClassroom.vue')
	},

	// 教师端
	{
		path: '/teacher',
		component: () => import('@/views/teacher/Index'),
		redirect: '/teacher/dashboard',
		children: [{
				path: 'dashboard',
				component: () => import('@/views/teacher/TeachClass/index.vue')
			},
			{
				path: 'interactiveClassroom',
				component: () => import('@/views/teacher/TeachClass/interactiveClassroom.vue')
			},
			{
				path: 'schoolModelManagement',
				component: () => import('@/views/teacher/model/index.vue')

			},
			{
				path: 'PageConfigAdmin',
				component: () => import('@/views/admin/manage/ClassManage/PageConfigAdmin.vue')

			},
			// 观课
			{
				path: 'WatchTheClass',
				component: () => import('@/views/teacher/TeachClass/WatchTheClass.vue')
			},
			// 历史课堂
			{
				path: 'class-history',
				component: () => import('@/views/teacher/TeachClass/classHistory.vue')
			},
			//暂时集成csv
			{
				path: 'canvasWrap',
				component: () => import('@/views/components/wrap.vue')
			},

			// 查看记录
			{
				path: 'viewClass',
				component: () => import('@/views/teacher/TeachClass/components/index.vue')
			},
			{
				path: 'teach',
				component: () => import('@/views/teacher/TeachClass/index.vue')
			},
			{
				path: 'school',
				component: () => import('@/views/teacher/SchoolManage/index.vue')
			},
			// 小组
			{
				path: 'teamManagement',
				component: () => import('@/views/teacher/classList/teamManagement.vue')
			},
			{
				path: 'AgentSchoolManagement',
				component: () => import('@/views/collective/index.vue')
			},
			//测试注入的逻辑
			{
				path: 'postMessage',
				component: () => import('@/views/components/postMessage.vue')
			},
		]
	},

	// 管理员
	{
		path: '/admin/login',
		component: () => import('@/views/admin/Login')
	},
	{
		path: '/admin/dashboard',
		component: () => import('@/views/admin/Dashboard')
	},
	{
		path: '/admin/PageConfigAdmin',
		component: () => import('@/views/admin/manage/ClassManage/PageConfigAdmin.vue')

	},
	{
		path: '/admin/school/subject/edit',
		component: () => import('@/views/admin/manage/BasicSettings/components/SchoolSubjectEdit.vue')

	},


	{
		path: '/school/semester/detail',
		component: () => import('@/views/admin/manage/BasicSettings/components/SchoolSemesterDetail.vue')

	},
]

const router = new VueRouter({
	mode: 'hash',
	routes
})

// ==========================
// 路由守卫（已修复，自动适配 /test/ 不会跳错）
// ==========================
router.beforeEach((to, from, next) => {
	const whiteList = ['/login', '/admin/login', '/teacher/WatchTheClass']
	const token = localStorage.getItem('token')
	const userType = localStorage.getItem('userType')
	if ((to.query.data||to.query.type)&&token) {
		// 清除本地缓存，屏蔽免登
		localStorage.clear()
		
		// 携带data参数跳登录页，用于自动登录
		return next({
			path: '/login',
			query: to.query
		})
	}
	if (token&&!to.query.data) {
		if (to.path === '/login') {
			// 学生
			if (userType === '3') {
				return next('/student/home')
			}
			// 教师（userType=2）→ 跳教师控制台
			else if (userType === '2') {
				return next('/teacher/dashboard')
			} else {
				return next()
			}
		}

		if (to.path === '/admin/login') {
			return next('/admin/dashboard')
		}
	}

	if (whiteList.includes(to.path)) {
		return next()
	}

	if (!token) {
		if (to.path.startsWith('/admin')) {
			return next('/admin/login')
		} else {
			return next('/login')
		}
	}

	next()
})

export default router